import { render, staticRenderFns } from "./addSpeciality.vue?vue&type=template&id=c71f933a"
import script from "./addSpeciality.vue?vue&type=script&lang=js"
export * from "./addSpeciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports